<span (click)="openClickToCallWidget(number)" class="material-icons click-to-call">call</span>
